import { Injectable, inject, signal, computed, effect } from "@angular/core";
import { RouteDataService } from "src/app/route-data.service";


@Injectable({
  providedIn: 'root',
})
export class DashboardSearchService{
  private routeService = inject(RouteDataService);
  private searchable = signal(false);
  searchEnabled = computed(()=> this.searchable())
  searchTerm = signal('');

  constructor(){
    effect(() => {
      if(this.routeService.routeChangeSignal()) {
        this.searchable.set(false);
        this.searchTerm.set('')
      }
    }, {allowSignalWrites: true});
  }

  enableSearch(){
    this.searchable.set(true);
  }
}
